import { Tag } from '@cian/components';
import * as React from 'react';

import { ERepair } from '../../../../json_query';
import { IRepairTag } from '../../../state/tags/definitions/repair';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IRepairTagItemProps {
  tag: IRepairTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const materialsMap = {
  [ERepair.Cosmetic]: 'Косметический ремонт',
  [ERepair.Design]: 'Дизайнерский ремонт',
  [ERepair.Euro]: 'Евроремонт',
  [ERepair.Without]: 'Без ремонта',
};

export const RepairTagItem = (props: IRepairTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {materialsMap[props.tag.value]}
    </TagComponent>
  );
};
